import { WEBSITE } from '../../api'
import { useLandingLang } from '../../hooks/useLandingLang'
import { Tab } from '../../components/Tab'
import { useHomeContext } from '../HomeContext'
import { useMemo } from 'react'
import styled from 'styled-components/macro'
import { isOnDemandVisible } from '../../featureFlags'

export const LinkTabs = () => {
    const t = useLandingLang()
    const { data, hostId, selectedContent, setSelectedContent, attachMomenceLeadId } = useHomeContext()

    const tabs = useMemo(
        () => [
            <Tab key="tab-1" selected={selectedContent === 'live'} onClick={() => setSelectedContent('live')}>
                {t('CLASS_SCHEDULE')}
            </Tab>,
            data?.isAppointmentScheduleVisible && (
                <Tab
                    key="tab-2"
                    onClick={() =>
                        (window.location.href = attachMomenceLeadId(
                            `${WEBSITE}/appointments/appointment-reservation/${hostId}`
                        ))
                    }
                >
                    {t('BOOK_APPOINTMENTS')}
                </Tab>
            ),
            data?.hasOnDemandAddon && isOnDemandVisible(hostId) && (
                <Tab
                    key="tab-3"
                    selected={selectedContent === 'store'}
                    onClick={() => (window.location.href = attachMomenceLeadId(`${WEBSITE}/video/plugin/${hostId}`))}
                >
                    {!!data.numberOfCourses ? t('ONDEMAND_VIDEOS_AND_COURSES') : t('VIDEO_LIBRARY')}
                </Tab>
            ),
        ],
        [
            attachMomenceLeadId,
            data?.isAppointmentScheduleVisible,
            data?.hasOnDemandAddon,
            data?.numberOfCourses,
            hostId,
            selectedContent,
            setSelectedContent,
            t,
        ]
    )

    if (tabs.filter(t => !!t).length <= 1) {
        return null
    }

    return <TabsContainer>{tabs}</TabsContainer>
}

const TabsContainer = styled.div`
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    overflow-x: auto;
    & > * + * {
        margin-left: 2rem;
    }
`
